<template>
    <DsCard>
        <div class="flex flex-col items-center justify-center p-2">
            <slot name="image">
                <DsIcon
                    v-if="icon"
                    class="mb-4 text-content-primary"
                    :icon
                    size="lg"
                />
            </slot>
            <h3 class="mb-1 text-content-lg font-medium text-content-primary">{{ title }}</h3>
            <p class="text-content-md text-content-secondary">
                {{ description }}
            </p>
            <p
                v-if="$slots['action']"
                class="mt-4"
            >
                <slot name="action" />
            </p>
        </div>
    </DsCard>
</template>

<script setup lang="ts">
import DsCard from '@ds/DsCard.vue';
import DsIcon from '@ds/DsIcon.vue';
import type { FontAwesomeIconProps } from '@fortawesome/vue-fontawesome';

defineProps<{
    icon?: FontAwesomeIconProps['icon'];
    title: string;
    description: string;
}>();

defineSlots<{
    action: () => void;
    image: () => void;
}>();
</script>
